export const THEMES_BASE_URL = '/v1/themes';
export const PRODUCT_SECTIONS_URL = `${THEMES_BASE_URL}/product-sections`;
export const PRODUCTS_ORDER_URL = `${THEMES_BASE_URL}/products-order`;
export const CONTACT_INFO_URL = `${THEMES_BASE_URL}/contact-info`;
export const PASSWORD_PROTECTED_URL = `${THEMES_BASE_URL}/password-protected`;
